module.exports = __webpack_public_path__ + "img/uk-ill-defined-causes-male.175948a8.png";